function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 4.77h2.77V2H2v2.77zM6.615 14h2.77v-2.77h-2.77V14zM4.77 14H2v-2.77h2.77V14zM2 9.385h2.77v-2.77H2v2.77zm7.385 0h-2.77v-2.77h2.77v2.77zM11.23 2v2.77H14V2h-2.77zM9.385 4.77h-2.77V2h2.77v2.77zm1.846 4.615H14v-2.77h-2.77v2.77zM14 14h-2.77v-2.77H14V14z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/grid.bf730b93.svg";
export { SvgComponent as ReactComponent };